export default __webpack_public_path__ + "img/768651e09bbed629c5a17a2e7e4abbf5.svg";